/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lessons_BookInputs */

const en_lessons_book = /** @type {(inputs: Lessons_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Book A Lesson`)
};

const es_lessons_book = /** @type {(inputs: Lessons_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reservar una lección`)
};

const de_lessons_book = /** @type {(inputs: Lessons_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golfstunde buchen`)
};

const zh_lessons_book = /** @type {(inputs: Lessons_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`预约课程`)
};

const ar_lessons_book = /** @type {(inputs: Lessons_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`احجز درساً`)
};

const fr_lessons_book = /** @type {(inputs: Lessons_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réservez une leçon`)
};

const vi_lessons_book = /** @type {(inputs: Lessons_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đặt buổi học`)
};

const sw_lessons_book = /** @type {(inputs: Lessons_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weka nafasi ya somo`)
};

const th_lessons_book = /** @type {(inputs: Lessons_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`จองบทเรียน`)
};

const bs_lessons_book = /** @type {(inputs: Lessons_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rezervišite lekciju`)
};

const ja_lessons_book = /** @type {(inputs: Lessons_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`レッスンを予約する`)
};

const ko_lessons_book = /** @type {(inputs: Lessons_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`레슨 예약`)
};

const pt_lessons_book = /** @type {(inputs: Lessons_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agende uma aula`)
};

const it_lessons_book = /** @type {(inputs: Lessons_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prenota una lezione`)
};

const sv_lessons_book = /** @type {(inputs: Lessons_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boka en lektion`)
};

const nl_lessons_book = /** @type {(inputs: Lessons_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boek een les`)
};

const da_lessons_book = /** @type {(inputs: Lessons_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Book en lektion`)
};

const nb_lessons_book = /** @type {(inputs: Lessons_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestill en time`)
};

const fi_lessons_book = /** @type {(inputs: Lessons_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Varaa oppitunti`)
};

const pl_lessons_book = /** @type {(inputs: Lessons_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarezerwuj lekcję`)
};

const ru_lessons_book = /** @type {(inputs: Lessons_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Записаться на урок`)
};

const tr_lessons_book = /** @type {(inputs: Lessons_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ders ayırtın`)
};

const hi_lessons_book = /** @type {(inputs: Lessons_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पाठ बुक करें`)
};

const id_lessons_book = /** @type {(inputs: Lessons_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesan pelajaran`)
};

const ms_lessons_book = /** @type {(inputs: Lessons_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempah pelajaran`)
};

const cs_lessons_book = /** @type {(inputs: Lessons_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarezervujte si lekci`)
};

const el_lessons_book = /** @type {(inputs: Lessons_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Κλείστε μάθημα`)
};

const he_lessons_book = /** @type {(inputs: Lessons_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הזמינו שיעור`)
};

const af_lessons_book = /** @type {(inputs: Lessons_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boek 'n les`)
};

const hu_lessons_book = /** @type {(inputs: Lessons_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Óra foglalása`)
};

/**
* | output |
* | --- |
* | "Book A Lesson" |
*
* @param {Lessons_BookInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const lessons_book = /** @type {((inputs?: Lessons_BookInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lessons_BookInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_lessons_book(inputs)
	if (locale === "de") return de_lessons_book(inputs)
	if (locale === "zh") return zh_lessons_book(inputs)
	if (locale === "ar") return ar_lessons_book(inputs)
	if (locale === "fr") return fr_lessons_book(inputs)
	if (locale === "vi") return vi_lessons_book(inputs)
	if (locale === "sw") return sw_lessons_book(inputs)
	if (locale === "th") return th_lessons_book(inputs)
	if (locale === "bs") return bs_lessons_book(inputs)
	if (locale === "ja") return ja_lessons_book(inputs)
	if (locale === "ko") return ko_lessons_book(inputs)
	if (locale === "pt") return pt_lessons_book(inputs)
	if (locale === "it") return it_lessons_book(inputs)
	if (locale === "sv") return sv_lessons_book(inputs)
	if (locale === "nl") return nl_lessons_book(inputs)
	if (locale === "da") return da_lessons_book(inputs)
	if (locale === "nb") return nb_lessons_book(inputs)
	if (locale === "fi") return fi_lessons_book(inputs)
	if (locale === "pl") return pl_lessons_book(inputs)
	if (locale === "ru") return ru_lessons_book(inputs)
	if (locale === "tr") return tr_lessons_book(inputs)
	if (locale === "hi") return hi_lessons_book(inputs)
	if (locale === "id") return id_lessons_book(inputs)
	if (locale === "ms") return ms_lessons_book(inputs)
	if (locale === "cs") return cs_lessons_book(inputs)
	if (locale === "el") return el_lessons_book(inputs)
	if (locale === "he") return he_lessons_book(inputs)
	if (locale === "af") return af_lessons_book(inputs)
	if (locale === "hu") return hu_lessons_book(inputs)
	return en_lessons_book(inputs)
});